import { combineReducers } from 'redux';
import { requestReducer } from './request-feature';
import { userReducer } from "./user-feature";

export const rootReducer = combineReducers({ user: userReducer, requests: requestReducer});

export default rootReducer;